import React, { useState } from 'react';
import Header from '../Components/Header/Header';
import DirectQuiz from '../Components/Quiz/DirectQuiz';
import MultipleQuiz from '../Components/Quiz/MultipleQuiz'


function Quiz() {
  const [quizType, setQuizType] = useState(null); // null, 'direct', or 'multiple'

  return (
    <div>
      <Header />
      
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        {!quizType ? (
          <div className="text-center max-w-md w-full">
            <h2 className="text-3xl font-bold text-gray-800 mb-8">Choose Quiz Type</h2>
            
            <div className="grid gap-6">
              <button
                onClick={() => setQuizType('direct')}
                className="px-6 py-4 bg-blue-600 text-white rounded-xl shadow-lg hover:bg-blue-700 transition transform hover:scale-105"
              >
                <h3 className="text-xl font-semibold">Direct Answer Quiz</h3>
                <p className="mt-2 text-blue-100">Type answers to questions</p>
              </button>
              
              <button
                onClick={() => setQuizType('multiple')}
                className="px-6 py-4 bg-green-600 text-white rounded-xl shadow-lg hover:bg-green-700 transition transform hover:scale-105"
              >
                <h3 className="text-xl font-semibold">Multiple Choice Quiz</h3>
                <p className="mt-2 text-green-100">Select from given options</p>
              </button>
            </div>
          </div>
        ) : quizType === 'direct' ? (
          <DirectQuiz onBack={() => setQuizType(null)} />
        ) : (
          <MultipleQuiz onBack={() => setQuizType(null)} />
        )}
      </div>
    </div>
  );
}

export default Quiz;